import { appApi } from "../api";
import { TrackList } from "@/@types/app/TrackList";

export type TrackListFormData = {
	title: string;
	description: string;
	thumbnailFile?: File;
};

export async function registerTrackList(trackListFormData: TrackListFormData) {
	if (!trackListFormData.thumbnailFile) return false;
	const formData = new FormData();
	formData.append("thumbnailFile", trackListFormData.thumbnailFile);
	formData.append("title", trackListFormData.title);
	formData.append("description", trackListFormData.description);
	const response = await appApi.post("/tracklist/register", formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.status === 200;
}

export async function updateTrackListImage(
	trackListId: number,
	trackListFormData: TrackListFormData
) {
	if (!trackListFormData.thumbnailFile) return;
	const formData = new FormData();
	if (trackListFormData.thumbnailFile) {
		formData.append("thumbnailFile", trackListFormData.thumbnailFile);
	}
	formData.append("id", String(trackListId));
	const response = await appApi.post("/tracklist/updateimage", formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.status === 200;
}

export async function updateTrackList(trackList: TrackList) {
	const response = await appApi.post("/TrackList/Update", { id: trackList.id, ...trackList });
	return response.status === 200;
}

export async function getTrackListById(trackListId: number) {
	const { data } = await appApi.get<TrackList>("/tracklist/GetById", { trackListId });
	return data || ({} as TrackList);
}

export async function getAllTrackLists() {
	const { data } = await appApi.get<TrackList[]>("/tracklist/all");
	return data || [];
}
